import { useEffect, useRef } from "react";
import { WarningOutlined } from "@material-ui/icons"; 

export default function DeleteItemModal({ onConfirm, onClose, isLoading }) {
  const cancelRef = useRef(null);

  useEffect(() => {
    cancelRef.current?.focus();
  }, []);

  useEffect(() => {
    const onKeyDown = (e) => {
      if (e.key === "Escape" && !isLoading) onClose();
    };
    document.addEventListener("keydown", onKeyDown);
    return () => document.removeEventListener("keydown", onKeyDown);
  }, [isLoading, onClose]);

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget && !isLoading) onClose();
  };

  return (
    <div
      className="delete-item-modal__overlay"
      onClick={handleOverlayClick}
      role="presentation"
    >
      <div
        role="dialog"
        aria-modal="true"
        aria-labelledby="delete-item-modal-title"
        className="delete-item-modal__dialog"
        tabIndex={-1}
      >
        <div className="delete-item-modal__icon-wrap" aria-hidden="true">
          <WarningOutlined style={{ color: "#F64E60", fontSize: 36 }} />
        </div>

        <h2 id="delete-item-modal-title" className="delete-item-modal__title">
          Deseja excluir este produto?
        </h2>

        <p className="delete-item-modal__message">
          Ao confirmar, este produto não poderá mais ser utilizado por novos
          clientes da Jusfy. Para clientes que já possuem o adicional, ele
          ficará disponível até o próximo mês.
        </p>

        <div className="delete-item-modal__footer">
          <button
            ref={cancelRef}
            type="button"
            className="delete-item-modal__btn delete-item-modal__btn--cancel"
            onClick={onClose}
            disabled={isLoading}
          >
            Cancelar
          </button>

          <button
            type="button"
            className="delete-item-modal__btn delete-item-modal__btn--confirm"
            onClick={onConfirm}
            disabled={isLoading}
          >
            {isLoading ? (
              <>
                <span
                  className="spinner-border spinner-border-sm mr-2"
                  role="status"
                  aria-hidden="true"
                />
                Excluindo...
              </>
            ) : (
              "Excluir produto"
            )}
          </button>
        </div>
      </div>
    </div>
  );
}